module.exports = __webpack_public_path__ + "static/media/breadcrumb00.8e560c77.png";